import { Stack, Typography, getSpacing, pn, replaceSpacesWithUnderscores } from "@compass/core";
import { AprResponseActivitiesAndServices, ReportPropertyBase } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import "moment-timezone";

export const ActivitiesAndServices = (props: { title: string; response: AprResponseActivitiesAndServices }) => {
  return (
    <Stack spacing="lg">
      <Typography fontSize={"1.15rem"}>{props.title}</Typography>

      <Stack pl={getSpacing("md")} spacing="md">
        <Typography variant="inherit">
          What is the total, unduplicated number of students that actively participated in one or more GEAR UP
          activities during the reporting period?
        </Typography>
        <Typography variant="h6">{props.response.studentCount}</Typography>
      </Stack>

      <Stack pl={getSpacing("md")} spacing="md">
        <Typography variant="inherit">
          What is the total, unduplicated number of educators that actively participated in one or more GEAR UP
          activities during the reporting period?
        </Typography>
        <Typography variant="h6">{props.response.staffCount}</Typography>
      </Stack>

      <Stack pl={getSpacing("md")} spacing="md">
        <Typography variant="inherit">
          What is the total, unduplicated number of students with parents, guardians, or other family members that
          actively participated in one or more GEAR UP activities during the reporting period?
        </Typography>
        <Typography variant="h6">{props.response.parentCount}</Typography>
      </Stack>
    </Stack>
  );
};
